
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"27","viewBox":"0 0 26 27","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13.5","r":"13","fill":"#07193D"}}),_c('path',{attrs:{"fill":"#07193D","d":"M4.161 4.4h18.46v18.46H4.161z"}}),_c('path',{attrs:{"d":"M13.12 8.278c-.555-.692-1.918-1.305-3.432-1.305-2.004 0-3.619 1.03-4.015 1.997v10.07c0 .549.36.757.75.757.317 0 .497-.093.691-.245.411-.353 1.24-.829 2.574-.829 1.327 0 2.256.462 2.617.786.188.151.418.289.815.289.389 0 .612-.152.807-.289.382-.303 1.29-.785 2.617-.785 1.333 0 2.17.482 2.574.828.194.152.375.246.692.246.39 0 .75-.21.75-.757V8.97c-.397-.966-2.012-1.997-4.016-1.997-1.514 0-2.877.613-3.424 1.305zM6.833 9.316C7 8.869 8.045 8.06 9.688 8.06c1.637 0 2.704.815 2.848 1.255v9.119c-.685-.512-1.73-.8-2.848-.8-1.124 0-2.17.288-2.855.829V9.316zm12.566 0v9.148c-.685-.54-1.73-.83-2.855-.83-1.117 0-2.163.29-2.848.801v-9.12c.144-.439 1.211-1.254 2.848-1.254 1.643 0 2.69.808 2.855 1.255z","fill":"#fff"}})])
          )
        }
      }
    